import * as React from "react";
import { formatText } from "bernie-l10n";
import { inject } from "mobx-react";

import { DestinationVideoProps } from "./typings";

import {
  Action,
  FlexTrackingInfo,
  sendDelayedTrackEvent
} from "components/utility/analytics/FlexAnalyticsUtils";

export const DestinationVideo = inject("analytics")((props: DestinationVideoProps) => {
  const { flexComponent, context } = props;
  const { model } = flexComponent;

  const videoUrl = model && model.embeddedUrl;
  if (!videoUrl) {
    return null;
  }

  const title = model && model.title;

  /* covered in e2e test */
  /* istanbul ignore next line */
  React.useEffect(() => {
    const { analytics } = props;

    const trackVideoClick = () => {
      const { activeElement } = document;
      if (activeElement && activeElement.id === "destination-video-iframe") {
        const flexTrackingInfo: FlexTrackingInfo = {
          moduleName: "destination-video",
          action: Action.CLICK,
          rfrr: "video.play"
        };

        sendDelayedTrackEvent(flexTrackingInfo, analytics);
      }
    };

    window.addEventListener("blur", trackVideoClick);

    return () => {
      window.removeEventListener("blur", trackVideoClick);
    };
  }, []);

  return (
    <div className="DestinationVideo uitk-cell all-cell-1-1" id={flexComponent.id}>
      {title && <h2 className="uitk-type-heading-600 all-b-margin-four">{title}</h2>}

      <div className="video-container">
        <iframe
          id="destination-video-iframe"
          title={formatText(
            "destinationVideo.video.forDestination",
            context.searchContext.location.defaultName
          )}
          src={videoUrl}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen={true}
        />
      </div>
    </div>
  );
});

export default DestinationVideo;
